// If mobile device is pwa, show decrypt pwa data.
// Else, prompt user to download the pwa
export const isPWA = window.matchMedia("(display-mode: standalone)").matches;
